import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Siempre pensé que el Tarot era demasiado difícil. Compré Tarot Listo porque quería aprender desde cero y terminé haciendo mis primeras lecturas el mismo fin de semana.',
  name: 'Mariana G.',
  role: 'Buenos Aires 🇦🇷'
}, {
  quote: 'Por fin dejé de depender del librito. El Diccionario Intuitivo y las Lecturas Reales fueron lo que más me ayudó. Ahora entiendo cómo conectar las cartas entre sí.',
  name: 'Daniela R.',
  role: 'Ciudad de México 🇲🇽'
}, {
  quote: 'Sentía que necesitaba un don para leer el Tarot. Este kit me hizo entender que lo importante es aprender el lenguaje de las cartas y practicar.',
  name: 'Valeria C.',
  role: 'Bogotá 🇨🇴'
}, {
  quote: 'Vale muchísimo más de lo que cuesta. Solo los bonos ya justifican el precio. Me encantó la organización y lo fácil que resulta seguir cada paso.',
  name: 'Sofía L.',
  role: 'Santiago 🇨🇱'
}, {
  quote: 'Ahora disfruto cada lectura. Antes me frustraba porque no sabía interpretar varias cartas juntas. Hoy puedo hacer lecturas completas sin sentirme perdida.',
  name: 'Paula M.',
  role: 'Montevideo 🇺🇾'
}];
export function TestimonialsSection() {
  return <section className="px-5 relative overflow-hidden" data-id="element-294">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-295">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-petroleum mb-16 tracking-tight" data-id="element-296">
          ⭐ Lo que dicen nuestros compradores
        </h2>

        <div className="space-y-8" data-id="element-297">
          {testimonials.map((c, i) => <div key={i} className="bg-brand-soft-cream rounded-[32px] p-8 md:p-10 shadow-premium border border-brand-petroleum/5 transition-all hover:bg-white" data-id="element-298">
              <div className="flex gap-1 mb-8" data-id="element-299">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-brand-gold-warm text-brand-gold-warm" data-id="element-300" />)}
              </div>
              <p className="text-brand-dark-grey italic text-base md:text-lg mb-10 leading-relaxed font-medium" data-id="element-301">
                "{c.quote}"
              </p>
              <div className="flex items-center gap-5 pt-8 border-t border-brand-petroleum/5" data-id="element-302">
                <div className="w-12 h-12 rounded-full bg-brand-gold-warm/10 border border-brand-gold-warm/20 flex items-center justify-center text-brand-gold-warm font-bold text-lg" data-id="element-303">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-304">
                  <p className="font-bold text-brand-petroleum text-sm tracking-tight" data-id="element-305">
                    {c.name}
                  </p>
                  <p className="text-[10px] text-brand-medium-grey font-semibold uppercase tracking-widest" data-id="element-306">
                    {c.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}